module.exports = __webpack_public_path__ + "static/media/Checkout.9857d2aa.svg";